import styled from 'styled-components';

export const SubWrapper = styled.div`
  padding: 2rem 0;
  background: #4790d6;
  color: #ffff;
`;

export const Title = styled.h3`
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const Description = styled.p`
  span {
    display: block;
  }
`;
